module.exports = __webpack_public_path__ + "static/tree-hero-a5f7bcf06048cae437d5624acdb3556f.png";